import React, { useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { EMAIL_MOBILE_REGEX } from "../config/constant";
import { RequestLoginOtp } from "../api/Login";
import { tostW } from "../config/tostConfig";

export default function Login({ onNext }) {
  const [loading, setLoading] = useState(false);
  const validationSchema = Yup.object().shape({
    emailOrMobile: Yup.string().required("Email or Mobile is required").matches(EMAIL_MOBILE_REGEX, "Please enter a valid email or mobile number"),
  });

  const formik = useFormik({
    initialValues: {
      emailOrMobile: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      const body = {
        email_phone: values.emailOrMobile,
      };

      try {
        const res = await RequestLoginOtp(body);
        if (res.status === 200 && res.data.success) {
          onNext(values.emailOrMobile);
        }else {
          tostW(res.data.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const { touched, errors, getFieldProps, handleSubmit} = formik;

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="emailOrMobile">Existing members, login below</label>
          <input
            type="text"
            id="emailOrMobile"
            className="form-control"
            placeholder="Enter your Email ID or Mobile Number"
            name="emailOrMobile"
            {...getFieldProps("emailOrMobile")}
          />
          {touched.emailOrMobile && errors.emailOrMobile && <small className="text-danger">{errors.emailOrMobile}</small>}
        </div>
        <div className="text-center">
          {/* <button className="btn back btn-primary mx-2">Back</button> */}
          <button className="btn btn-primary mx-2" type="submit" disabled={loading}>
            Next
          </button>
        </div>
      </Form>
    </FormikProvider>
  );
}
